// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__u6fL8","heading":"styles_heading__HdTqJ","image_container":"styles_image_container__O4_vr","text":"styles_text__KONWG"};